module.exports = __webpack_public_path__ + "img/eraser.440faaf0.svg";